/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DetailUserViewModel } from "../types/DetailUserViewModel.ts";

export const detailUserViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  userName: z.string().nullish(),
  role: z.string().nullish(),
  roleId: z.optional(z.number().int()),
  temporaryPassword: z.string().nullish(),
  language: z.string().nullish(),
  comunicationLanguage: z.string().nullish(),
  isEmailVerified: z.optional(z.boolean()),
}) as unknown as ToZod<DetailUserViewModel>;
